export default __webpack_public_path__ + "static/media/NEXON Lv1 Gothic Low OTF.078a0a30.woff";